var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVolumeOffIcon = function SvgVolumeOffIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 131",
    d: "M27.665 32.504a1.279 1.279 0 01-1.059-.569 1.264 1.264 0 01-.074-1.255l1.487 1.772a1.237 1.237 0 01-.354.052zm-10.591-2.5a1.231 1.231 0 01-.874-.367l-4.634-4.633H6.25A1.252 1.252 0 015 23.75v-7.5a1.252 1.252 0 011.25-1.246h5.316l.986-.985 5.781 6.885v7.843a1.243 1.243 0 01-1.259 1.257zm14.717-.834l-1.659-1.977a12.171 12.171 0 00-3.164-17.38 1.261 1.261 0 111.383-2.109 14.692 14.692 0 013.441 21.46zm-7.266-.88a1.272 1.272 0 01-.714-.536 1.254 1.254 0 01-.188-.542l.9 1.076zm3.949-3.073l-1.715-2.044a7.123 7.123 0 00-2.565-9.179 1.267 1.267 0 01-.385-1.738 1.244 1.244 0 011.724-.389 9.653 9.653 0 012.943 13.349zM24.9 20.951l-3.877-4.62a1.254 1.254 0 011.595-.333 4.576 4.576 0 012.385 4 4.526 4.526 0 01-.1.951zm-6.567-7.825L16.1 10.465l.1-.1a1.231 1.231 0 01.874-.367 1.243 1.243 0 011.26 1.251v1.877z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1878",
    width: 3,
    height: 36,
    rx: 1.5,
    transform: "rotate(-40 14.034 -7.885)",
    fill: "#fff"
  })));
};
export default SvgVolumeOffIcon;